<!--
Copyright 2022 LINE Fukuoka Corporation

LINE Corporation licenses this file to you under the Apache License,
version 2.0 (the "License"); you may not use this file except in compliance
with the License. You may obtain a copy of the License at:

  https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
License for the specific language governing permissions and limitations
under the License.
-->
<template>
  <div>
    <v-radio-group v-model="input" :rules="[validateRequired]" hide-details>
      <ul class="linearscale" style="padding-left: 0">
        <li>{{ params.scale_min.message }}</li>
        <li v-for="scale in scales" :key="scale">
          {{ scale }}
          <span><v-radio :value="scale"></v-radio></span>
        </li>
        <li>{{ params.scale_max.message }}</li>
      </ul>
    </v-radio-group>
  </div>
</template>

<style>
.v-radio {
  display: block;
}
ul.linearscale {
  display: table;
  table-layout: fixed;
  padding-left: 0;
  margin: auto;
  width: 100%;
}
ul.linearscale li {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.v-application--is-ltr .v-input--selection-controls__input {
  margin-right: 0;
}
</style>

<script>
import Vue from "vue";
import InputBase from "./InputBase.vue";

export default Vue.extend({
  name: "InputLinearscale",
  mixins: [InputBase],
  prosp: {
    isLiffMode: Boolean,
    isAdminMode: Boolean,
  },
  created() {
    this.itemKey = this.params.itemKey;
    var params = Object.assign(
      {
        isRequired: { value: false },
        isRequiredForUser: { value: false },
        scale_max: { value: 10, message: "" },
        scale_min: { value: 0, message: "" },
        input: undefined,
      },
      this.params
    );

    this.scales = [];
    for (
      var i = this.params.scale_min.value;
      i <= this.params.scale_max.value;
      i++
    ) {
      this.scales.push(i);
    }
    this.required = params.isRequired;
    this.isRequiredForUser = params.isRequiredForUser.value;
    this.scale_max = params.scale_max;
    this.scale_min = params.scale_min;
    this.input = params.input;
  },
  methods: {
    getValue() {
      return this.input;
    },
    validateRequired(input) {
      const isValid = !!input;
      if (this.isAdminMode) {
        return !this.required || isValid;
      } else if (this.isLiffMode) {
        return (!this.required && !this.isRequiredForUser) || isValid;
      }
    },
  },
});
</script>
